"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const PredictionManager_1 = require("../../../data/PredictionManager");
const spectrumSimulation_1 = require("../../../data/data1d/spectrumSimulation");
const Label_1 = __importDefault(require("../../elements/Label"));
const Select_1 = __importDefault(require("../../elements/Select"));
const FormikInput_1 = __importDefault(require("../../elements/formik/FormikInput"));
const FormikSelect_1 = __importDefault(require("../../elements/formik/FormikSelect"));
const SPIN_SYSTEMS = (0, spectrumSimulation_1.getSpinSystems)().map((key) => ({
    label: key,
    value: key,
}));
const labelStyle = {
    label: { fontSize: '10px' },
    wrapper: { display: 'flex', alignItems: 'center', height: '100%' },
    container: { padding: '0 5px', height: '100%' },
};
const selectStyles = { width: '100%', minWidth: '75px', fontSize: '10px' };
function SpectrumSimulationSimpleOptions({ onSpinSystemChange, spinSystem, }) {
    return ((0, jsx_runtime_1.jsxs)("div", { style: {
            display: 'flex',
            justifyContent: 'flex-end',
            flex: '1',
        }, children: [(0, jsx_runtime_1.jsx)(Label_1.default, { title: "", style: labelStyle, children: (0, jsx_runtime_1.jsx)(Select_1.default, { items: SPIN_SYSTEMS, style: selectStyles, onChange: onSpinSystemChange, value: spinSystem }) }), (0, jsx_runtime_1.jsx)(Label_1.default, { title: "Frequency", style: labelStyle, children: (0, jsx_runtime_1.jsx)(FormikSelect_1.default, { items: PredictionManager_1.FREQUENCIES, style: selectStyles, name: "options.frequency" }) }), (0, jsx_runtime_1.jsxs)(Label_1.default, { title: "Line Width", style: labelStyle, children: [(0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: "options.lineWidth", type: "number", style: {
                            input: {
                                width: '40px',
                                textAlign: 'center',
                            },
                        } }), (0, jsx_runtime_1.jsx)("span", { style: { padding: '0 5px' }, children: "Hz" })] })] }));
}
exports.default = SpectrumSimulationSimpleOptions;
